import React from "react";
import { Tooltip } from "antd";

const ProportionLine = ({
  keptPercentage,
  removedPercentage,
  keptColor = "#65e1b9",
  removedColor = "#ededed",
  borderRadius = 4,
  patternFill = false,
  patternFillKept = false,
  patternFillRemoved = false,
    keptText='Kept',
    removedText='Removed'
}) => {
  const width = 120; // Total width of the SVG
  const height = 14; // Height of the SVG

  // Normalize values to ensure they sum to 1 (or 100%)
  const totalPercentage = keptPercentage + removedPercentage;
  const normalizedKeptPercentage = totalPercentage > 0 ? keptPercentage / totalPercentage : 0;
  const normalizedRemovedPercentage = totalPercentage > 0 ? removedPercentage / totalPercentage : 0;

  const keptWidth = normalizedKeptPercentage * width;
  const removedWidth = normalizedRemovedPercentage * width;

  // Format percentages for display
  const keptPercentageDisplay = (normalizedKeptPercentage * 100).toFixed(1) + "%";
  const removedPercentageDisplay = (normalizedRemovedPercentage * 100).toFixed(1) + "%";

  return (
    <Tooltip
      title={
        <div>
          <div>{keptText}: {keptPercentageDisplay}</div>
          <div>{removedText}: {removedPercentageDisplay}</div>
        </div>
      }
    >
      <svg width={width} height={height} style={{ filter: "url(#shadow)", cursor: "pointer" }}>
        {/* Define Gradients and Filters */}
        <defs>
          {/* Gradient for Kept */}
          <linearGradient id="keptGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: keptColor, stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: "#4abf98", stopOpacity: 1 }} />
          </linearGradient>

          {/* Gradient for Removed */}
          <linearGradient id="removedGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: removedColor, stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: "#cfcfcf", stopOpacity: 1 }} />
          </linearGradient>

          {/* Box Shadow Filter */}
          <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#888" floodOpacity="0.6" />
          </filter>

          {/* Define Patterns */}
          {patternFill || patternFillKept ? (
            <pattern id="keptPattern" patternUnits="userSpaceOnUse" width="8" height="8">
              <line x1="0" y1="0" x2="8" y2="8" stroke={keptColor} strokeWidth="1" />
              <line x1="8" y1="0" x2="0" y2="8" stroke={keptColor} strokeWidth="1" />
            </pattern>
          ) : null}

          {patternFill || patternFillRemoved ? (
            <pattern id="removedPattern" patternUnits="userSpaceOnUse" width="4" height="4">
              <line x1="0" y1="0" x2="4" y2="4" stroke={removedColor} strokeWidth="1" />
              <line x1="4" y1="0" x2="0" y2="4" stroke={removedColor} strokeWidth="1" />
            </pattern>
          ) : null}
        </defs>

        {/* Kept Line */}
        <rect
          x={0}
          y={0}
          width={keptWidth}
          height={height}
          fill={patternFill || patternFillKept ? "url(#keptPattern)" : "url(#keptGradient)"}
          rx={borderRadius}
          ry={borderRadius}
        />
        {/* Removed Line */}
        <rect
          x={keptWidth}
          y={0}
          width={removedWidth}
          height={height}
          fill={patternFill || patternFillRemoved ? "url(#removedPattern)" : "url(#removedGradient)"}
          rx={borderRadius}
          ry={borderRadius}
        />
      </svg>
    </Tooltip>
  );
};

export default ProportionLine;
